import { render } from "./AlcoholAcknowledgementDialog.vue?vue&type=template&id=dce2bd46"
import script from "./AlcoholAcknowledgementDialog.vue?vue&type=script&lang=js"
export * from "./AlcoholAcknowledgementDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QCheckbox});
